import React, { Suspense, useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { CContainer, CSpinner } from '@coreui/react';

// routes config
import routes from '../routes';
import { AuthContext, Loading } from 'src/App';

const NotAuthorized = React.lazy(() => import('../views/pages/page404/PageNotAuthorized'));
const AppContent = () => {
    const Auth = useContext(AuthContext)
  return (
    <CContainer lg>
      <Suspense fallback={<CSpinner color="primary" />}>
        <Routes>
            {routes.map((route, idx) => {
            return (
                route.element && (
                <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    element={
                    !(JSON.parse(localStorage.getItem("userDetail"))[0]?.supervisor_id === 0 && Auth.isDenied(Auth.role[route.authKey])) ?
                        <route.element/>
                    :
                        Auth.isEmpty() ? 
                            <Loading/>
                        :
                            <NotAuthorized/>
                    }
                />
                )
            );
            })}
            <Route path="/" element={<Navigate to="dashboard" replace />} />
        </Routes>
      </Suspense>
    </CContainer>
  );
};

export default React.memo(AppContent);
